import { gql } from 'glimmer-apollo';

export const ESPORTS_BANNER_QUERY = gql`
  query {
    articles: eSportsArticles(limit: 4) {
      __typename
      title
      slug
      publishedDate
      shortDescription
      coverImage {
        url(width: 600, height: 400, fit: cover, format: webp)
      }
      author {
        name
        slug
        avatar {
          url(width: 60, height: 60, fit: cover, format: webp)
        }
      }
    }
  }
`;
